import { FC } from "react"
import Icon from "../../Fondations/Icons/Icon"
import style from "./Badge.module.css"

type BadgeSmallVariants =
  | "badge-small-error"
  | "badge-small-information"
  | "badge-small-success"
  | "badge-small-warning"
  | "badge-small-heart"
  | "badge-small-book"
  | "badge-small-logOut"
  | "badge-small-cross"
  | "badge-small-timer"
  | "badge-small-question"
type BadgeBigVariants =
  | "badge-big-error"
  | "badge-big-information"
  | "badge-big-success"
  | "badge-big-warning"
  | "badge-big-heart"
  | "badge-big-book"
  | "badge-big-logOut"
  | "badge-big-cross"
  | "badge-big-timer"
  | "badge-big-question"
export type BadgeVariants = BadgeSmallVariants | BadgeBigVariants

type BadgeSize = "xs" | "m"
type BadgeIconName =
  | "exclamation"
  | "info"
  | "checkThick"
  | "heart"
  | "book"
  | "logOut"
  | "cross"
  | "timer"
  | "question"

type BadgeVariantProps = {
  status: BadgeIconName
  size: BadgeSize
}
const badgeVariantToProps: Record<BadgeVariants, BadgeVariantProps> = Object.freeze({
  "badge-small-error": { status: "exclamation", size: "xs" },
  "badge-small-information": { status: "info", size: "xs" },
  "badge-small-success": { status: "checkThick", size: "xs" },
  "badge-small-warning": { status: "exclamation", size: "xs" },
  "badge-small-heart": { status: "heart", size: "xs" },
  "badge-small-book": { status: "book", size: "xs" },
  "badge-small-logOut": { status: "logOut", size: "xs" },
  "badge-small-cross": { status: "cross", size: "xs" },
  "badge-small-timer": { status: "timer", size: "xs" },
  "badge-small-question": { status: "question", size: "xs" },
  "badge-big-error": { status: "exclamation", size: "m" },
  "badge-big-information": { status: "info", size: "m" },
  "badge-big-success": { status: "checkThick", size: "m" },
  "badge-big-warning": { status: "exclamation", size: "m" },
  "badge-big-heart": { status: "heart", size: "m" },
  "badge-big-book": { status: "book", size: "m" },
  "badge-big-logOut": { status: "logOut", size: "m" },
  "badge-big-cross": { status: "cross", size: "m" },
  "badge-big-timer": { status: "timer", size: "m" },
  "badge-big-question": { status: "question", size: "m" },
})

type BadgeProps = {
  variant: BadgeVariants
}

export const Badge: FC<BadgeProps> = ({ variant }) => {
  return (
    <div className={style[variant]}>
      <Icon
        name={badgeVariantToProps[variant].status}
        size={badgeVariantToProps[variant].size}
      />
    </div>
  )
}
